export enum SwTypeEnum {
    VERSION_DETECTED = 'VERSION_DETECTED',
    VERSION_INSTALLATION_FAILED = 'VERSION_INSTALLATION_FAILED',
    VERSION_READY = 'VERSION_READY'
}
